export interface IAction {
  type: string;
  payload: any;
}
export const enum RecentlyListKey {
  RECENTLY_LISTED = 'recentlyListed',
  RECENTLY_SOLD = 'recentlySold',
}
export type TRecentlyListKey = 'recentlyListed' | 'recentlySold';
